import { useQuery } from "@tanstack/react-query";
import { produce } from "immer";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import { getFlowsByType } from "../utils";

import type { DetailedCampaign } from "../types";

async function getCampaignRequest(
  workspaceId: string,
  campaignId: string,
): Promise<DetailedCampaign> {
  const campaign = (
    await get(`workspaces/${workspaceId}/campaigns/${campaignId}`)
  ).campaign as DetailedCampaign;

  if (campaign.type === "drip") {
    return produce(campaign, (draftCampaign) => {
      const { primaryFlows } = getFlowsByType(draftCampaign.flows);
      for (let i = 0; i < primaryFlows.length; i += 1) {
        if (!primaryFlows[i].flow_message_templates.length) {
          primaryFlows[i].flow_message_templates = [
            {
              ai_descriptors: {},
              delay: 0,
              edited: false,
              message: "",
              original_id: null,
              type: "MESSAGE_TEMPLATE",
            },
          ];
        }
      }
    });
  }
  return campaign;
}
export default function useCampaignDetails(campaignId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const {
    data: campaign,
    isLoading: isLoadingCampaign,
    refetch: refetchCampaign,
    error: campaignError,
  } = useQuery<DetailedCampaign>({
    queryKey: campaignsKeys.details(campaignId),
    queryFn: () => getCampaignRequest(workspaceId, campaignId),
    enabled: !!campaignId,
  });

  return {
    campaign,
    campaignError,
    isLoadingCampaign,
    refetchCampaign,
  };
}
